import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TotpSetupResponse } from 'src/app/models/mfa/mfa.model';
import { REQUEST_AUTH_HEADER_KEY } from 'src/app/shared/app.const';
import { ApiService } from '../api.service';

/**
 * Required MFA setup after login answered `requireTotpGeneration: true`. Requests use the token
 * from that login response, which is kept in memory only — it never becomes the app session.
 */
@Injectable({
  providedIn: 'root',
})
export class MfaSetupService {
  private readonly BASE_URL = 'users/totp';

  private setupToken: string = null;

  constructor(private apiSvc: ApiService) {}

  get hasSetupToken() {
    return !!this.setupToken;
  }

  start(token: string) {
    this.setupToken = token;
  }

  clear() {
    this.setupToken = null;
  }

  /** QR code and secret for the authenticator. */
  getInfo(): Observable<TotpSetupResponse> {
    return this.apiSvc.get<TotpSetupResponse>(this.BASE_URL, this.authOptions(), false);
  }

  /** Confirms the setup with a code generated from the secret. */
  validate(code: string): Observable<void> {
    return this.apiSvc.post<void>(`${this.BASE_URL}/validate`, { code }, this.authOptions(), false);
  }

  /** Ends the setup session on the server. */
  logout(): Observable<void> {
    return this.apiSvc.get<void>('users/logout', this.authOptions(), false);
  }

  private authOptions() {
    return { headers: { [REQUEST_AUTH_HEADER_KEY]: `Bearer ${this.setupToken}` } };
  }
}
